import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppConfig {
  isLoading: boolean;
}

const initialState: AppConfig = {
  isLoading: false,
};

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const { setLoading, updateLoading } = appConfigSlice.actions;

export default appConfigSlice;
